<template>
  <div v-if="!itemsCount" class="catalog-not-found-banner">
    <DefTitle result="1" :center="true">
      <h2>{{ messages.help }}</h2>
    </DefTitle>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import DefTitle from '@components/Def/DefTitle/DefTitle.vue';

export default {
  name: 'CatalogNotFoundBanner',
  components: { DefTitle },
  computed: {
    ...mapState({
      messages: ({ results }) => results.messages,
      itemsCount: ({ catalog }) => catalog?.data?.catalogSectionList?.count,
    }),
  },
};
</script>

<style lang="scss" scoped>
.catalog-not-found-banner {
  background-color: #f5e6d8;
  padding: 32px 16px;
  margin-bottom: 64px;
  @include point-md {
    padding: 40px 32px;
    margin-bottom: 80px;
  }
  @include point-lg {
    padding: 35px;
  }
  :deep(.def-title) {
    margin-bottom: 0;
  }
}
</style>
